import { Label } from 'react-bootstrap';

const helpers = {
    comparePrevious: (previousValue, currentValue, lessIsBetter) => {
        if (previousValue != null && currentValue != null) {
            if (previousValue != currentValue) {
                if (lessIsBetter) {
                    return currentValue > previousValue ? 'label label-danger' : 'label label-success';
                } else {
                    return currentValue < previousValue ? 'label label-danger' : 'label label-success';
                }
            }
        }

        return null;
    },

    getYesNoUnknown: (value: number, yesIsBad: boolean = true) => {
        let description = value != null ? (value == 1 ? 'Yes' : 'No') : 'unknown';
        let yesClass = yesIsBad ? 'label label-danger' : 'label label-success';
        let noClass = yesIsBad ? 'label label-success' : 'label label-danger';
        let unknownClass = 'label label-default';
        let className = value === 1 ? yesClass : (value === null || value === -1 ? unknownClass : (value === 0 ? noClass : ''));

        return <span className={className} style={{ display: 'inline' }}>{description}</span>;
    },

    getBool: (boolVal, yesIsBad: boolean = true) => {
        if (typeof boolVal == 'boolean') {
            return helpers.getYesNoUnknown(boolVal === true ? 1 : 0, yesIsBad);
        } else {
            return helpers.getYesNoUnknown(boolVal, yesIsBad);
        }
    },

    getText: (value: any, showWarning: boolean, extra: string = '') => {
        if (value == null) {
            return <>[Not answered]</>
        }

        if (showWarning) {
            return <Label bsStyle='danger'>{value}{extra}</Label>
        } else {
            return <>{value}{extra}</>
        }
    }
}

export default helpers;